module.exports = {"152921102":"温都尔勒图镇","152921105":"巴润别立镇","152921110":"巴彦浩特镇","152921111":"嘉尔嘎勒赛汉镇","152921112":"吉兰泰镇","152921113":"宗别立镇","152921114":"敖伦布拉格镇","152921115":"腾格里额里斯镇","152921203":"巴彦木仁苏木乡","152921213":"乌力吉苏木乡","152921214":"巴彦诺日公苏木乡","152921215":"额尔克哈什哈苏木乡","152921216":"银根苏木","152921217":"超格图呼热苏木","152921401":"腾格里经济技术开发区","152921402":"巴彦浩特额鲁特街道","152921403":"巴彦浩特南环路街道","152921404":"巴彦浩特新华街道","152921405":"巴彦浩特王府街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/152921.json
// module id = 496
// module chunks = 0